import Icon from '../components/Icon.vue'

Icon.register({
  'info-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111.1 248 248 0 137-111 248-248 248s-248-111-248-248c0-136.9 111-248 248-248zM256 118c-23.2 0-42 18.8-42 42s18.8 42 42 42 42-18.8 42-42-18.8-42-42-42zM312 372v-24c0-6.6-5.4-12-12-12h-12v-100c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h12v64h-12c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h88c6.6 0 12-5.4 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/info-circle.js
// module id = 1489
// module chunks = 0